module.exports = "<div class=\"source-list-modal\">\n  <div class=\"modal-header small\">\n    <h3 class=\"modal-title\">\n      Required Hours for Timesheet\n    </h3>\n  </div>\n  <div class=\"modal-body\">\n    <p>Your timesheet must have the required hours</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-primary\" type=\"button\" ng-click=\"save()\">OK</button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./client/pages/timesheet/modals/required-hours/required-hours.html
// module id = 783
// module chunks = 0